
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import Trans from 'next-translate/Trans';
import useTranslation from 'next-translate/useTranslation';
// Hooks
import useUser from '@/utils/hooks/swr/useUser';
import useActiveTreeStructure from '@/utils/hooks/tree-structure/useActiveTreeStructure';
// Libs
import { PLATFORM_OPTIONS } from '@/routes/privateRoutes';
// Layout
import { WrapperSwitchLayout } from '@/components/layouts/wrappers/WrapperSwitchLayout';
import SettingsWrapper from '@/components/layouts/LayoutPlatform/components/SettingsWrapper';
// Components
import HeaderSettings from '@/components/pages/settings/HeaderSettings';
import H3 from '@/components/base/Headings/H3';
import { PlatformForm } from '@/components/pages/settings/platform/PlatformForm';
import Loader from '@/components/base/Loader';
import WrapperSettings from '@/components/pages/settings/WrapperSettings';
const OldPageContent = () => {
    const { isLoading: isUserLoading } = useUser();
    return (<>
            <HeaderSettings current={PLATFORM_OPTIONS}/>
            <WrapperSettings>
                <WrapperSettings.WrapperSettingsFirstColumn>
                    {isUserLoading ? (<Loader className="absolute left-1/2 top-1/2 mr-3 h-8 w-8 text-icoBlue"/>) : (<PlatformForm />)}
                </WrapperSettings.WrapperSettingsFirstColumn>
                <WrapperSettings.WrapperSettingsLastColumn>
                    <SideContent />
                </WrapperSettings.WrapperSettingsLastColumn>
            </WrapperSettings>
        </>);
};
const NewPageContent = () => {
    const { isLoading: isUserLoading } = useUser();
    return (<SettingsWrapper>
            <SettingsWrapper.MainContent>
                {isUserLoading ? (<div className="flex min-h-72 items-center justify-center">
                        <Loader className="h-8 w-8 text-icoBlue"/>
                    </div>) : (<PlatformForm />)}
            </SettingsWrapper.MainContent>
            <SettingsWrapper.SideContent>
                <SideContent />
            </SettingsWrapper.SideContent>
        </SettingsWrapper>);
};
const SideContent = () => {
    const { t } = useTranslation('settings');
    return (<div className="p-8 xl:px-7 xl:py-10">
            <H3 className="mb-m">
                <Trans i18nKey="settings:platform_page.setup_translation"/>
            </H3>
            <p className="font-GSemiBold text-xs leading-4 text-icoGray-500 dark:text-icoDarkMode-wolf">
                {t('platform_page.settings_platform_col_text')}
            </p>
        </div>);
};
const PageContent = () => {
    const { isTreeStructureActivated } = useActiveTreeStructure();
    if (isTreeStructureActivated) {
        return <NewPageContent />;
    }
    return <OldPageContent />;
};
export default function Platform() {
    return (<WrapperSwitchLayout noPadding={true} disableMainScroll={true}>
            <PageContent />
        </WrapperSwitchLayout>);
}

    async function __Next_Translate__getStaticProps__19440f62ff2__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/settings/platform',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__19440f62ff2__ as getStaticProps }
  